export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-youtube-42fffc05f572dd355f62c8e0f860478d.svg";